var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"iconfont",class:_vm.iconClass,style:(_vm.iconStyle),on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }